import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const mobileAppTutorialIcon = svgToTinyDataUri(
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="5" y="2" width="14" height="20" rx="2" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 18H12.01" stroke="#222222" stroke-width="2" stroke-linecap="round"/>
  <path d="M10 10L14 12L10 14V10Z" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
);
